/*
  Height and weight display, shared by both apps.

  The cm -> ft/in carry had been re-typed in three places (web's bio and
  compare, mobile's compare) and the pound conversion in four, each with its
  own spacing. Mobile's player bio was the one surface that never got the
  imperial half at all.
*/
/**
 * 182 -> `6'0"`.
 *
 * The leftover inches can round up to a full 12, which has to carry into the
 * foot rather than print as `5'12"`.
 */
export const cmToFeetAndInches = (cm) => {
    const totalInches = cm / 2.54;
    const feet = Math.floor(totalInches / 12);
    const inches = Math.round(totalInches % 12);
    if (inches === 12)
        return `${feet + 1}'0"`;
    return `${feet}'${inches}"`;
};
/** 75 -> `165lb`. */
export const kgToPounds = (kg) => `${Math.round(kg * 2.20462)}lb`;
/** 182 -> `1.82m (6'0")`. */
export const formatHeight = (cm) => cm != null ? `${cm / 100}m (${cmToFeetAndInches(cm)})` : undefined;
/** 75 -> `75kg (165lb)`. */
export const formatWeight = (kg) => kg != null ? `${kg}kg (${kgToPounds(kg)})` : undefined;
//# sourceMappingURL=measurements.js.map